<template>
  <div v-if="!$auth.loading && $auth.isAuthenticated" id="enterKey">
    <b-container class="login">
      <p>Please wait, logging you in...</p>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      currentScreen: 'enterKey',
      apiKey: 'testing-key',
    };
  },
  computed: {},
  mounted() {
    this.$emit('apikey', this.apiKey);
    this.$emit('screen', 'services');
  },
};
</script>
